import { render, staticRenderFns } from "./Claim.vue?vue&type=template&id=f7d8980e&"
import script from "./Claim.vue?vue&type=script&lang=ts&"
export * from "./Claim.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports